import React from 'react';

// Section Header Component - Reusable header for all sections
export function SectionHeader({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="px-6 py-4 border-b border-[hsl(var(--border))] bg-gradient-to-r from-[#E63946]/20 via-[#F97316]/15 to-transparent relative overflow-hidden rounded-t-xl">
      <div className="absolute inset-0 bg-gradient-to-r from-[#E63946]/10 to-transparent opacity-50" />
      <div className="relative flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-gradient-to-br from-[#E63946]/30 to-[#F97316]/20 border border-[#E63946]/40 shadow-[0_0_15px_-3px_#E63946]">
            <Icon size={20} className="text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-white font-heading">{title}</h3>
            <p className="text-xs text-[hsl(var(--text-muted))]">{subtitle}</p>
          </div>
        </div>
        {action && <div>{action}</div>}
      </div>
    </div>
  );
}

export default SectionHeader;
